import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { signOut } from "../../api/index";
import { logout } from '../../redux/reducer/user';
import { updateInfo } from '../../redux/reducer/tenant';
import defaultImg from '../../assets/img/International-SOS.png';

@withRouter
@connect(
  state=>state.tenant,
  { logout, updateInfo }
)
export default class Header extends Component{
  _signOut = () => {
    let { loginAdmin } = this.props;
    let tenantname = loginAdmin==="isos"?"":loginAdmin;
    signOut({}, {headers: {'tenantname': tenantname}})
      .then(()=>{
        this.props.logout();
      })
      .catch(err=>err);
  };

  _updateChosenTenant = e => {
    // if (e.target.innerText==="All Tenants") this.props.updateInfo({chosenTenant: "All Tenants"});
    // else this.props.updateInfo({chosenTenant: e.target.innerText});
    let array = this.props.tenantList.slice();
    let text = e.target.innerText;
    sessionStorage.setItem("chosenTenant", text);
    sessionStorage.setItem("chosenTenantName", array.find(v=>v.companyName===text)?(array.find(v=>v.companyName===text)).name:"");
    sessionStorage.setItem("chosenIndex", array.findIndex(v=>v.companyName===text));
    this.props.updateInfo({
      chosenTenant: text,
      tenantInfo: array.find(v=>v.companyName===text)
    });
    if (text !== this.props.chosenTenant) {
      location.reload();
      // this.props.history.push('/admin/dashboard');
      // if (this.props.location.pathname === "/admin/dashboard" ) {
      //   location.reload();
      // }
    }
  };

  render() {
    let miniLogoUrl;
    let { loginAdmin, chosenTenant, tenantInfo, tenantList } = this.props;
    let addClass = loginAdmin==="isos"?"":"normal";
    if (tenantInfo) miniLogoUrl = tenantInfo.miniLogo;
    return (
      <header id="header">
        <div id="logo-group">
          <span id="logo" style={{marginTop: 6}}>
            <img src={defaultImg} style={{width: 40, height: 40}} />
          </span>
          {
            miniLogoUrl ?
              <span id="activity" className="activity-dropdown" style={{border: 0}}>
                <img src={miniLogoUrl} style={{width: 40, height: 40, cursor: 'default'}} />
              </span>
              :
              <span id="activity" className="activity-dropdown">
                <i className="fa fa-user" />
              </span>
          }
        </div>

        <div id="project-context" className={`project-context hidden-xs ${addClass}`}>
          <span className="label">TENANTS:</span>
          <span className="project-selector dropdown-toggle" data-toggle="dropdown" aria-expanded="false">
            {/*{(loginAdmin==="isos"&&chosenTenant==="")?"All Tenants":chosenTenant}&nbsp;*/}
            {chosenTenant}&nbsp;
            {loginAdmin==="isos" && tenantList.length > 0 && <i className="fa fa-angle-down" />}
          </span>
          {
            loginAdmin==="isos" && tenantList.length > 0 &&
            <ul className="dropdown-menu">
              {/*<li>*/}
                {/*<a href="javascript:" onClick={this._updateChosenTenant}>*/}
                  {/*All Tenants*/}
                {/*</a>*/}
              {/*</li>*/}
              {
                tenantList.map((tenant, index)=>{
                  return (
                    <li key={index}>
                      <a href="javascript:" onClick={this._updateChosenTenant}>
                        {tenant.companyName}
                      </a>
                    </li>
                  );
                })
              }
            </ul>
          }
        </div>

        <div className="btn-header transparent pull-right" id="logout">
          <span>
            <a title="Sign Out" onClick={this._signOut}>
              <i className="fa fa-sign-out" />
            </a>
          </span>
        </div>
      </header>
    );
  }
}



// WEBPACK FOOTER //
// ./src/component/dashboard/header.js